<template>
  <div class="content">
    <div class="tit">支付成功</div>
    <div class="btns">

      <van-button type="primary" :color="$abctheme.basecolor" :to="baseurl">查看订单</van-button>
      <van-button type="primary" :color="$abctheme.basecolor" :to="basehome">返回首页</van-button>
    </div>
    <div style="text-align: center; margin-top: 30px" v-if="qrcodeurl">
      <p style="color: red; font-size: 14px">我的专属客服,长按识别添加微信</p>
      <img style="width: 200px; height: 200px" :src="$baseurl + qrcodeurl" />
    </div>
	<div style="padding:20px">
		<van-button v-if="halfrecordnum" type="primary" round to="/retailhalfprice" style="margin-bottom:10px;" color="linear-gradient(to right, #ff6034, #ee0a24)" block>恭喜您获得{{halfrecordnum}}张半价券(点击查看)</van-button>

    <van-button v-if="winlotterynum" type="primary" round to="/newdrawlottery"  color="linear-gradient(to right, #ff6034, #ee0a24)" block>恭喜您获得{{winlotterynum}}张抽奖券(点击查看)</van-button>
	</div>
    <!-- <van-cell-group>
			<van-cell title="查看订单"  is-link to="/home" />
            <van-cell title="返回首页"  is-link to="/home" />
        </van-cell-group> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseurl: "/user/order",
      basehome: "/home",
      qrcodeurl: "",
      halfrecordnum: 0,
      winlotterynum:0
    };
  },
  created() {
    this.qrcodeurl = "";
    this.baseurl = localStorage.getItem("paysuccessnavurl");
    if (this.abp.userInfo.memberLevelModel.isRetail) {
      this.baseurl = "/retailorder";
      this.basehome = "/retailpage";
      // this.ajax.post('/api/services/app/PhoneUser/QueryMySuperiorWxQrCode').then(x=>{
      //     this.qrcodeurl=x.result;
      // })
      
      if (tid) {
        localStorage.setItem("paysuccesstid", "");
        this.ajax
          .post("/api/services/app/PhoneUser/QueryHalfActiveRecordByTradeId?tid=" + tid)
          .then((x) => {
            this.halfrecordnum = x.result;
          });
          // this.ajax.post('/api/services/app/PhoneDrawLottery/QueryWinLotteryForTid?tid='+tid).then(x=>
          // {
          //     this.winlotterynum=x.result;
          // })
          setTimeout(() => {
            this.ajax.post('/api/services/app/PhoneDrawLottery/QueryWinLotteryForTid?tid='+tid).then(x=>
            {
                this.winlotterynum=x.result;
            })
          }, 1000);
          // setTimeout(() => {
          //   this.ajax.post('/api/services/app/PhoneDrawLottery/QueryWinLotteryForTid?tid='+tid).then(x=>
          //   {
          //       this.winlotterynum=x.result;
          //   })
          // }, );
       
      }
      
    }else
    {
        let tid = localStorage.getItem("paysuccesstid");
        if (tid) {
          localStorage.setItem("paysuccesstid", "");
          setTimeout(() => {
            this.ajax.post('/api/services/app/PhoneDrawLottery/QueryWinLotteryForTid?tid='+tid).then(x=>
            {
                this.winlotterynum=x.result;
            })
          }, 1000);
         
        }
    }
    this.getUserInfo().then();
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.tit {
  text-align: center;
  font-size: 30px;
  padding: 10px;
  margin-top: 100px;
}
.btns button {
  display: block;
  width: 80%;
  margin-left: 10%;
  margin-top: 10px;
  border-radius: 20px;
}
</style>
